const DevConfig = {
    VITE_API_URL: "https://digital-library-dev-api.unilever.com/api",
    VITE_CLIENT_ID: "4f3c4a73-081e-4159-8c3e-d7027add07ae",
    VITE_TENANT_ID: "f66fae02-5d36-495b-bfe0-78a6ff9f8e6e",
    VITE_FUNC_KEY_CODE: "OmznRyREnWQ6Qdr_O26JWvhmy-mgKYPQbEGUVcEWkHdbAzFu089nrA=="
  };
  
  const UatConfig = {
    VITE_API_URL: "https://digital-library-qa-api.unilever.com/api",
    VITE_CLIENT_ID: "cb2cb38d-b5ec-451b-b6a6-049b2a02483a",
    VITE_TENANT_ID: "f66fae02-5d36-495b-bfe0-78a6ff9f8e6e",
    VITE_FUNC_KEY_CODE:
      "Cq74aJ3kv49LwfXHU33j0EvCdiyu48JUBZcETiKKMTLrAzFuMWL4aw%3D%3D"
  };
  
  const ProdConfig = {
    VITE_API_URL: "https://digital-library-api.unilever.com/api",
    VITE_CLIENT_ID: "04201add-e93e-47a8-82d5-bd12fd37bd74",
    VITE_TENANT_ID: "f66fae02-5d36-495b-bfe0-78a6ff9f8e6e",
    VITE_FUNC_KEY_CODE: "iuWJ85or_822y5gGJLk4V7vgEVQz4jQ4gh2debolZ82CAzFugPgPrA=="
  };
  
  const configByEnv = () => {
    if (typeof document !== "undefined") {
      var host = document.location.host;
  
      if (
        host.match("fragrancebankuiuamdev.azurewebsites") ||
        host.includes("fragrancebankuiuamdev.azurewebsites") ||
        host.includes("digital-library-uam-dev.unilever") ||
        host.match("digital-library-uam-dev.unilever") ||
        host.includes("localhost")
      ) {
        return DevConfig;
      } else if (
        host.includes("fragrancebankuiuamqa.azurewebsites") ||
        host.match("fragrancebankuiuamqa.azurewebsites") ||
        host.includes("digital-library-uam-qa.unilever") ||
        host.match("digital-library-uam-qa.unilever")
      ) {
        return UatConfig;
      } else {
        return ProdConfig;
      }
    }
  };
  
  export const config = configByEnv();
  
